<template>
  <a-card :bordered="false" style="width: 100%;text-align: center;">
    <div class="content" v-show="currentTab==0">
      <a-form :form="form" style="max-width: 500px; margin: 40px auto 0;" @keyup.enter.native="nextStep">
        <a-form-item
          label="检验码"
          :labelCol="{span: 5}"
          :wrapperCol="{span: 19}">
          <a-input
            type="text"
            autocomplete="false"
            style="width:310px;margin-left:-10px"
            v-decorator="['emailValidCode',{ rules: validatorRules.username.rule}]"
            placeholder="请输入密码重置检验码">
          </a-input>
        </a-form-item>
        <a-form-item
          :labelCol="{span: 5}"
          :wrapperCol="{span: 19}"
          label="新密码">
          <a-input style="width:310px;margin-left:-10px" type="password" placeholder="请输入新密码" v-decorator="[ 'password', validatorRules.password]" />
        </a-form-item>

        <a-form-item
          :labelCol="{span: 5}"
          :wrapperCol="{span: 19}"
          label="确认新密码">
          <a-input style="width:310px;margin-left:-10px" type="password" @blur="handleConfirmBlur" placeholder="请确认新密码" v-decorator="[ 'confirmpassword', validatorRules.confirmpassword]"/>
        </a-form-item>
        <a-form-item :wrapperCol="{span: 19, offset: 5}">
          <router-link style="float: left;line-height: 40px;" :to="{ name: 'login' }">使用已有账号登录</router-link>
          <a-button type="primary" @click="nextStep" style="margin-left: 20px">下一步</a-button>
        </a-form-item>
      </a-form>
    </div>
    <div class="content" v-show="currentTab==1">
      密码重置成功！
      <a-form-item :wrapperCol="{span: 19, offset: 5}">
        <router-link style="float: left;line-height: 40px;" :to="{ name: 'login' }">使用已账号户登录</router-link>
      </a-form-item>
    </div>
  </a-card>
</template>

<script>
  import {postAction,putAction} from '@/api/manage'
  import md5 from '@/utils/md5.js'
  import { validatePhone, validateEmail } from '@/utils/common.js'
  import JSEncrypt from 'jsencrypt'

  export default {
    name: "resetPwd",
    components: {

    },
    data() {
      return {
        description: '忘记密码，邮箱找回',
        currentTab: 0,
        userList: {},
        emailValidStr: "",
        // form
        form: this.$form.createForm(this),

        validatorRules: {
          username: {rule: [{required: true, message: '请输入账号!'}, {}]},
          email: {rule: [{required: true, message: '请输入邮箱地址!'}, {validator: validateEmail}]},
          password:{
            rules: [{
              required: true, message: '请输入新密码!',
            }, {
              validator: this.validateToNextPassword,
            }],
          },
          confirmpassword:{
            rules: [{
              required: true, message: '请确认新密码!',
            }, {
              validator: this.compareToFirstPassword,
            }],
          }
        },
      }
    },
    created(){
      this.emailValidStr = this.$route.query.code;
    },
    methods: {
      cmsFailed(err) {
        this.$notification['error']({
          message: "验证错误",
          description: err,
          duration: 4,
        });
      },
      nextStep() {
        let that = this
        that.loading = true
        this.form.validateFields((err, values) => {
          console.log(values);
          if (!err) {
            postAction("/sys/loadRsa").then(res=>{
              if(res.success){
                var params = {}
                params.emailValidCode = values.emailValidCode;
                params.emailValidStr = this.emailValidStr;

                //私钥
                let publicKey = res.result
                params.publicKey = publicKey
                let encryptor = new JSEncrypt();
                encryptor.setPublicKey(publicKey);
                let encrypedPwd = encryptor.encrypt(values.password)
                params.password  = encrypedPwd

                //params.password = md5(md5(values.password.trim()).toUpperCase()).toUpperCase();
                putAction("/sys/user/resetPwd", params).then((res) => {
                  if (res.success) {
                    this.currentTab = 1;
                  } else {
                    this.cmsFailed(res.message);
                  }
                })
              }
            }).catch((err) => {
            });
          }
        })
      },
      validateToNextPassword  (rule, value, callback) {
        const form = this.form;
        if (value && this.confirmDirty) {
          form.validateFields(['confirm'], { force: true })
        }
        callback();
      },
      compareToFirstPassword  (rule, value, callback) {
        const form = this.form;
        if (value && value !== form.getFieldValue('password')) {
          callback('两次输入的密码不一样！');
        } else {
          callback()
        }
      },
      handleConfirmBlur  (e) {
        const value = e.target.value
        this.confirmDirty = this.confirmDirty || !!value
      }
    }
  }
</script>

<style lang="less" scoped>
  .steps {
    max-width: 750px;
    margin: 16px auto;
  }
</style>